import { render, staticRenderFns } from "./BooleanAttributeValue.vue?vue&type=template&id=2e4ff5db"
import script from "./BooleanAttributeValue.vue?vue&type=script&lang=ts"
export * from "./BooleanAttributeValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports